import React from 'react'
import Lottie from 'lottie-react'
import animationData from '../../../assets/animations/priwall_loader.json'
import { Box } from '../MaterialExports'

interface MpLoadingIconProps {
  positioned?: boolean
}
const MpLoadingIcon = (props: MpLoadingIconProps) => {
  return props.positioned ? (
    <Box
      mt="60px"
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center">
      <Lottie animationData={animationData} alt="loading..." style={{ width: 188, height: 188 }} />
    </Box>
  ) : (
    <Lottie animationData={animationData} alt="loading..." style={{ width: 188, height: 188 }}  />
  )
}

export default MpLoadingIcon
